<template>
  <v-container class="pa-0">
    <v-layout wrap>
      <v-flex xs12>
        <v-card-text style="font-size: large">
          {{$tf('In order to send you notifications through WhatsApp we first need your consent:')}}
          <br>
          <br>
          {{$tf('I accept that Idonia can notify me of the changes that occur in the files to which I have access, through') + ' '}}
          <img
              class="d-inline mx-1"
              width="130px"
              height="39px"
              src="../../../../assets/WhatsApp_Logo_5.png" alt="WhatsApp Logo"/>


          {{$tf('using the following telephone number:')}}

          <v-alert
              dismissible
              class="warning mt-2 body-2"
              style="border: none"
          v-model="showAlert">{{$tf('You need to provide a verified phone number to be able to receive notifications through WhatsApp')}}</v-alert>
          <phone-input class="mt-2"></phone-input>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import bus from '~/bus'
  import PhoneInput from '~/components/common/PhoneInput.vue'
  import {useBusUtils} from '~/commons/busUtils'
  const {BusHandlerManager} = useBusUtils()
  const bhm = new BusHandlerManager()
  export default {
    name: 'DialogWhatsappOptIn',
    components: {PhoneInput},
    props: {
      callback: {
        type: Function,
        default: () => ({})
      }
    },
    data () {
      return {
        showAlert: false
      }
    },
    mounted () {
      bhm.addHandler(bus, 'readyToAcceptOptIn', () => {
        this.accept(true)
      })
      this.$store.dispatch('dialog/setValid', false)
      if (this.phone && this.phoneVerified) {
        this.$store.dispatch('dialog/setValid', true)
      }
    },
    destroyed () {
      bhm.cleanAll()
    },
    watch: {
      phone: {
        immediate: true,
        handler: function (v) {
          if (!v) {
            this.$store.dispatch('dialog/setValid', false)
          }
        }
      },
      phoneVerified: {
        immediate: true,
        handler: function (v) {
          this.$store.dispatch('dialog/setValid', v)
        }
      }
    },
    computed: {
      phoneVerified () {
        return this.$store.state.session.account.phone_verified
      },
      phone () {
        return this.$store.state.session.account.phone
      }
    },
    methods: {
      cancel () {
      },
      async accept (fromEnter) {
        if (this.phone && this.phoneVerified) {
          await this.$store.dispatch('contracts/acceptContract', {name: 'whatsapp_opt_in', version: 1})
          let contracts = await this.$store.dispatch('contracts/loadAccepted')
          if (contracts && contracts.findIndex(e => e.name === 'whatsapp_opt_in') > -1) {
            bus.$emit('whatsappContractAccepted')
            if (fromEnter === true) {
              this.callback()
              this.$store.dispatch('dialog/closeDialog')
            }
          }
        } else {
          this.showAlert = true
          let err = {error: 'no empty phone'}
          throw err
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogWhatsappOptIn.vue